
import { Component, Prop, Vue } from 'vue-property-decorator';
import { LeaveRequestInterface } from '@/services/Calendar/leaves/interfaces';
import { DataTableHeader } from 'vuetify';

@Component({})
export default class UpcomingLeavesComponent extends Vue {
  @Prop() private upcomingLeaves!: LeaveRequestInterface[];
  private headers: DataTableHeader[] = [
    { text: 'Type', value: 'leaveType.name', sortable: false },
    { text: 'Dates', value: 'date', sortable: false },
    { text: 'Days', value: 'days', sortable: false },
  ];
}
